import { DIALOG_TABLE_MAX_HEIGHT } from '../../../../lib/const';
import { MATERIALS_SELECT as LABELS } from './labels.js';

export default {
  data: [],

  option: {
    highlightCurrentRow: true,
    selection: false,
    searchShow: false,
    searchBtn: true,
    addBtn: false,
    columnBtn: false,
    refreshBtn: false,
    menu: false,
    index: true,
    indexLabel: LABELS.serialNumber,
    border: true,
    searchSpan: 12,
    searchMenuSpan: 12,
    maxHeight: DIALOG_TABLE_MAX_HEIGHT,
    column: [
      {
        slot: true,
        label: LABELS.checked,
        width: 50,
        prop: 'checked'
      },
      {
        label: LABELS.materialNumber,
        prop: 'materialNumber',
        editDisplay: false,
        searchSpan: 12,
        search: true
      },
      {
        label: LABELS.materialName,
        prop: 'materialName',
        editDisplay: false,
        searchSpan: 12,
        search: true
      },
      {
        label: LABELS.materialDescription,
        prop: 'materialDesc',
        editDisplay: false,
        searchSpan: 12,
        search: true
      },
      {
        label: LABELS.specifications,
        prop: 'materialSpecifications',
        editDisplay: false
      },
      {
        label: LABELS.units,
        prop: 'baseUnit',
        editDisplay: false
      },
      {
        label: LABELS.factory,
        prop: 'factory',
        editDisplay: false,
        search: true
      }
      // {
      //   label: '预估单价',
      //   prop: 'budgetPrice'
      // }
    ]
  },
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  }
};
